import { normalizeDateString, toDateObject, formatAsIsoDate } from "./holidayFormatting.mjs";

// Simple helper to decide day highlight based on available kinds
// Priority: non-working > short-day > pending > approved; anything else -> null
export function decideHighlight(kinds) {
  if (!kinds) return null;
  const set = kinds instanceof Set ? kinds : new Set(kinds);
  if (set.has('non-working')) return 'non-working';
  if (set.has('short-day')) return 'short-day';
  if (set.has('pending')) return 'pending';
  if (set.has('approved')) return 'approved';
  return null;
}

export function buildShortDaySetFromNonWorking(nonWorkingDays = []) {
  const result = new Set();
  nonWorkingDays.forEach((entry) => {
    const iso = normalizeDateString(entry?.occurrence_date || entry?.date);
    const date = toDateObject(iso);
    if (!iso || !date) return;
    const weekday = date.getDay();
    const prevDate = new Date(date);
    prevDate.setDate(prevDate.getDate() - 1);
    const prevIso = formatAsIsoDate(prevDate);
    if (!prevIso) return;
    // marcăm doar zilele lucrătoare (exclude weekend pentru marker)
    const prevWeekday = prevDate.getDay();
    if (prevWeekday === 0 || prevWeekday === 6) return;
    result.add(prevIso);
  });
  return result;
}
